'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var hysdk = require('../src/');
var api = require('../src/apis/');

var sniff = hysdk.sniff,
    space = void 0;

var _ref = navigator.userAgent.toLowerCase().match("(^|\\s)(qunar[^\\/]+)\\/([\\d\\.]+)") || [];

var _ref2 = _slicedToArray(_ref, 4);

sniff.qunar = _ref2[0];
space = _ref2[1];
sniff.scheme = _ref2[2];
sniff.appVersion = _ref2[3];

sniff.qunar = !!sniff.qunar;

api.openCashier = {
    hy: {
        key: 'hbCashier'
    }
};

api.starLogin = {
    hy: {
        key: 'star.login'
    }
};

hysdk.supportStarLogin = function () {
    var qunar = sniff.qunar,
        android = sniff.android,
        ios = sniff.ios,
        appVersion = sniff.appVersion,
        scheme = sniff.scheme;

    var supportAppSchemes = ['qunariphone', 'quanriphonedeals', 'qunariphonepro', 'qunaraphone'];
    if (qunar && supportAppSchemes.indexOf(scheme) > -1) {
        if (android && parseInt(appVersion, 10) >= 60001169) return true;
        if (ios && parseInt(appVersion, 10) >= 80011137) return true;
    }
    return false;
};

hysdk.registerScheme('getAuthCode', 'scheme://pcenter/syncLoginForCtrip');

module.exports = hysdk;


//////////////////
// WEBPACK FOOTER
// ./hysdk.ctrip.js
// module id = 1
// module chunks = 0